/**
 * Where a thread's diff is taken from.
 *
 * A thread on a worktree diffs against that worktree; a thread working in the
 * project itself diffs against the project's checkout. The worktree wins when
 * both exist — that is the whole point of a worktree — and neither existing is
 * a real state, not an error, because a thread can be selected before its
 * project has loaded.
 */
export function resolveDiffCheckoutPath(input: {
  readonly threadWorktreePath?: string | null | undefined;
  readonly projectCwd?: string | null | undefined;
}): string | undefined {
  return input.threadWorktreePath ?? input.projectCwd ?? undefined;
}

/**
 * Whether the checkout is a git repository.
 *
 * Optimistic while unknown: the panel's own empty state is a better thing to
 * show during a status fetch than "this is not a git repository", which is a
 * claim the app cannot yet make.
 */
export function resolveIsGitRepo(
  status: { readonly isRepo?: boolean } | null | undefined,
): boolean {
  return status?.isRepo ?? true;
}
